export default __webpack_public_path__ + "static/media/50.f0d2a8a5.svg";